import Vue from 'vue'
import VueRouter from 'vue-router'
import customerRouter from '@/views/customer-mangement/router'
import adminRoute from '@/views/admin/route'
import creditManageRoute from '@/views/credit-management/route'
import businessHierarchyRoute from '@/views/business-hierarchy/route'
import workQueueRoute from '@/views/work-queue/route'
import documentsRoute from '@/views/documents/route'
import reportsRoute from '@/views/reports/route'
import ai from '@/views/ai/route'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/dashboard',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/components/home/home'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/dashboard/dashboard'
          ),
      },
      customerRouter,
      adminRoute,
      creditManageRoute,
      businessHierarchyRoute,
      workQueueRoute,
      documentsRoute,
      reportsRoute,
      ai,
    ],
  },
  {
    path: '/user',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user'),
    children: [
      {
        path: '/user/login',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: "login" */ '@/views/user/login'),
      },
      {
        path: '/user/forgot-password',
        name: 'forgot-password',
        component: () =>
          import(
            /* webpackChunkName: "login" */ '@/views/user/forgot-password'
          ),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
  },
]

const router = new VueRouter({
  routes,
})

router.afterEach(() => {
  const home = document.getElementsByClassName('home')[0]
  if (home) {
    home.scrollTop = 0
  }
})

export default router
